import(/* webpackMode: "eager", webpackExports: ["TermsOfService"] */ "/vercel/path0/frontend_next/src/screens/user/TermsOfService.tsx");
